module.exports = __webpack_public_path__ + "img/1.48d9fb66.png";